export function redirectToMxi(barcode) {
  window.open(
    "https://ifsmx.icelandair.is/maintenix/servlet/ScanBarcode?aBarcodeScan=" + barcode,
    "_blank"
  ); return true;
}